import {isAuthenticatedAndSalesman} from "./auth";
import React from "react";
import {  Route,  Redirect } from "react-router-dom";
import Template from "../components/Template";
// eslint-disable-next-line
export default  ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={props =>
            isAuthenticatedAndSalesman() ? (
                <Template>
                    <Component {...props} />
                </Template>
            ) : (
                <Redirect to={{ pathname: "/dashboard", state: { from: props.location } }}  from={'/'}/>
            )
        }
    />
);
